var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmergencyHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1307_9017",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1307_9017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54739 6.54228H6.45289V3.54228H5.54739V6.54228ZM6.00014 8.07278C6.12548 8.07278 6.23227 8.02865 6.32052 7.9404C6.40877 7.85215 6.45289 7.74653 6.45289 7.62353C6.45289 7.50052 6.40877 7.39373 6.32052 7.30315C6.23227 7.21257 6.12548 7.16728 6.00014 7.16728C5.87481 7.16728 5.76802 7.21257 5.67977 7.30315C5.59152 7.39373 5.54739 7.50052 5.54739 7.62353C5.54739 7.74653 5.59152 7.85215 5.67977 7.9404C5.76802 8.02865 5.87481 8.07278 6.00014 8.07278ZM6.00014 11.6363L0.36377 5.9999L6.00014 0.363525L11.6365 5.9999L6.00014 11.6363Z",
    fill: "#D0213D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyHome);
export default __webpack_public_path__ + "static/media/emergency_home.3e0081ea1c3dd8587f35f0094b3202f4.svg";
export { ForwardRef as ReactComponent };